import { render, staticRenderFns } from "./DealForm.vue?vue&type=template&id=0bba796e&scoped=true&"
import script from "./DealForm.vue?vue&type=script&lang=js&"
export * from "./DealForm.vue?vue&type=script&lang=js&"
import style0 from "./DealForm.vue?vue&type=style&index=0&id=0bba796e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba796e",
  null
  
)

export default component.exports